import React from "react";
import {
  AlertBanner,
  AlertBannerContent,
  AlertBannerDescription,
  Button,
  GlobeIcon,
  Icon,
} from "@commonsku/design-system";
import { CustomDomainStep } from "../popups/CustomDomainPopups/customDomainEntry";
interface CustomDomainBannerStatusBannerProps {
  currentDomainEntry: CustomDomainStep;
  openPopup: () => void;
}

const bannerVariants = {
  verification: {
    status: "info",
    icon: <GlobeIcon />,
    description: "Your custom domain is ready to launch.",
    buttonText: "Verify",
  },
  connect: {
    status: "info",
    icon: <GlobeIcon />,
    description: "Your custom domain is ready to launch.",
    buttonText: "Verify",
  },
  disconnect: {
    status: "success",
    icon: <GlobeIcon />,
    description: "Your custom domain is now active.",
    buttonText: "Disconnect",
  },
  blocked: {
    status: "error",
    icon: <GlobeIcon />,
    description: "Something went wrong with your custom domain.",
    buttonText: "Verify",
  },
};

const CustomDomainBannerStatusBanner = ({
  currentDomainEntry,
  openPopup,
}: CustomDomainBannerStatusBannerProps) => {
  return (
    <AlertBanner
      variant="subtle"
      width="auto"
      inline
      mr={6}
      size="md"
      paddingTop={0}
      paddingBottom={0}
      marginTop="auto"
      marginBottom="auto"
      colorPalette={bannerVariants[currentDomainEntry]?.status}
    >
      <AlertBannerContent>
        <Icon ariaLabel="custom domain globe icon" color="brand" size="md">
          {bannerVariants[currentDomainEntry]?.icon}
        </Icon>
        <AlertBannerDescription whiteSpace="nowrap">
          {bannerVariants[currentDomainEntry]?.description}
        </AlertBannerDescription>
        <Button
          onClick={openPopup}
          size="md"
          variant="ghost"
          marginRight={2}
          color="fg.link"
          paddingLeft={0}
          paddingRight={0}
          fontWeight="semibold"
        >
          {bannerVariants[currentDomainEntry]?.buttonText}
        </Button>
      </AlertBannerContent>
    </AlertBanner>
  );
};

export default CustomDomainBannerStatusBanner;
